export const TIMEZONE_COMPONENT_NAME: string = 'timezone'
